






































































import Vue from 'vue'
import Component from 'vue-class-component';

@Component
export default class Reporting extends Vue {
    name: string = 'Reporting';
    isLoading: boolean = true;

    mounted() {
        this.isLoading = false;
    }
}
